<template>
  <div
    :id="id"
    :style="{minHeight: minHeight, height: minHeight}"
    class="unlayer-editor"
  />
</template>

<script>
import {loadScript} from './loadScript'

let lastEditorId = 0

export default {
  name : 'UnlayerEditor',
  props: {
    editorId: {
      type   : String,
      default: ''
    },
    projectId: {
      type   : Number,
      default: undefined
    },
    options: {
      type   : Object,
      default: undefined
    },
    tools: {
      type   : Object,
      default: undefined
    },
    appearance: {
      type   : Object,
      default: undefined
    },
    locale: {
      type   : String,
      default: 'en'
    },
    minHeight: {
      type   : String,
      default: '700px'
    }
  },
  computed: {
    id() {
      return this.editorId || `editor-${++lastEditorId}`
    }
  },
  mounted() {
    loadScript(this.loadEditor.bind(this))
  },
  methods: {
    loadEditor() {
      const options = this.options || {}

      if (this.projectId) {
        options.projectId = this.projectId
      }

      if (this.tools) {
        options.tools = this.tools
      }

      if (this.appearance) {
        options.appearance = this.appearance
      }

      if (this.locale) {
        options.locale = this.locale
      }

      /* global unlayer */
      this.editor = unlayer.createEditor({
        id         : this.id,
        displayMode: options?.displayMode || 'email',
        ...options
      })

      this.$emit('load')

      this.editor.addEventListener('editor:ready', () => {
        this.$emit('ready')
      })
    },
    loadDesign(design) {
      this.editor.loadDesign(design)
    },
    saveDesign(callback) {
      this.editor.saveDesign(callback)
    },
    exportHtml(callback, options) {
      this.editor.exportHtml(callback, options)
    },
    exportPlainText(callback, options) {
      this.editor.exportPlainText(callback, options)
    },
    exportImage(callback, options) {
      this.editor.exportImage(callback, options)
    },
    exportPdf(callback, options) {
      this.editor.exportPdf(callback, options)
    },
    exportZip(callback, options) {
      this.editor.exportZip(callback, options)
    }
  }
}
</script>

<style scoped>
.unlayer-editor {
  flex: 1;
  display: flex;
}
</style>
